import { Check } from "lucide-react";

import { Button } from "./ui/button";
import Typography from "./ui/typography";

interface StripeConnectCardProps {
  stripeActive: boolean;
  connectUrl: string | null;
}

const StripeConnectCard = ({
  stripeActive,
  connectUrl,
}: StripeConnectCardProps) => {
  if (stripeActive) {
    // Connected state
    return (
      <div className="bg-[#f9f9f9] rounded-2xl p-6 space-y-4">
        <Typography size="l2" className="font-semibold text-[#494949]">
          Payment setup
        </Typography>
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center">
            <Check className="w-5 h-5 text-green-600" />
          </div>
          <div>
            <Typography size="b1" className="font-medium text-[#1e1e24]">
              Stripe Connected
            </Typography>
            <Typography size="b2" className="text-[#767677]">
              You're all set to receive payments from your clients.
            </Typography>
          </div>
        </div>
      </div>
    );
  }

  // Not connected state
  return (
    <div className="bg-[#f9f9f9] rounded-2xl p-6 space-y-4">
      <Typography size="l2" className="font-semibold text-[#494949]">
        Connect Stripe
      </Typography>
      <Typography size="b2" className="text-[#767677]">
        Connect your Stripe account to receive payouts.
      </Typography>
      <Button asChild className="bg-[#1e1e24] text-white hover:bg-[#333]">
        <a href={connectUrl || "#"} target="_blank" rel="noopener noreferrer">
          Connect
        </a>
      </Button>
    </div>
  );
};

export default StripeConnectCard;
